import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  dialog: {
    borderRadius: 12,
  },
  dialogTitle: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(2),
  },
  titleIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
    fontSize: 28,
  },
  dialogContent: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  dialogActions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 3),
  },
  submitButton: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  inputIcon: {
    marginRight: theme.spacing(1),
  },
  marginInfo: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
  },
}));
